import React from "react";
import { AlertTriangle } from "lucide-react";

import { Banner } from "@/main/react/component/Banner";

export function WarningBanner(props: {
    icon?: React.ElementType;
    title?: React.ReactNode;
    description: React.ReactNode;
    className?: string;
}) {
    const { icon, ...rest } = props;
    return <Banner variant="warning" icon={icon ?? AlertTriangle} {...rest} />;
}
